export const statusTypes = {
    NOT_VALIDATED: 'NOT_VALIDATED',
    VALIDATED: 'VALIDATED',
    CREATED: 'CREATED',
    PENDING: 'PENDING',
}
